import React from 'react';
import HeadPic from '../../../Assets/Image/png/Illustorator.png';
import { BtnAlternative, BtnPrimary } from '../buttons/Btn';
import { HashLink } from 'react-router-hash-link';

const Header = () => {
	return (
		<div className='header flex justify-between container items-center text-purple-dark-text mt-[6rem] mb-[12rem]'>
			<div className='header-content'>
				{/* <div>
          <img className="absolute left-0 top-32" src={homeRect} alt="" />
        </div> */}
				<h2 className='text-6xl w-[40rem] font-[900] leading-[6rem] mb-8'>
					ارتباط بدون محدودیت، یادگیری بدون فراموشی ، پشتیبانی بدون اتلاف
					وقت
				</h2>
				<span className='block text-[2.4rem] w-[38rem]  font-medium leading-[4.8rem] mb-24'>
					به سادگی آب خوردن، بوت‌کمپ خودت رو راه بنداز و بلیتشو بفروش!
				</span>
				<div className='flex gap-8'>
					<HashLink key='price' to='/price#top'>
						<BtnPrimary
							text='ایجاد بوت‌کمپ جدید'
							className='leading-10 px-6 py-3'
							type='button'
						/>
					</HashLink>
					<HashLink key='bootCamps' to='/bootcamp#top'>
						<BtnAlternative
							text='بوت‌کمپ‌های فعال'
							className='leading-10 px-6 py-3'
						/>
					</HashLink>
				</div>
			</div>
			<div className='header-pic'>
				<img src={HeadPic} alt='Illustorator' />
				<div className='header-pic-shape '></div>
			</div>
		</div>
	);
};

export default Header;


